import type { FC } from 'react';
import { TrackerTypeTag } from './TrackerTypeTag';

interface Props {
  width?: number;
}

export const ArchivedTrackerTypeTag: FC<Props> = ({ width = 60 }) => {
  return (
    <TrackerTypeTag
      color="gold"
      title="The device is archived. Tracker management is not charged for this device. No feature of tracker management is usable for this device. You have to unarchive the device in order to get advantage of tracker management."
      width={width}
    >
      archived
    </TrackerTypeTag>
  );
};
